export { default } from './FooterV2';
